import { azeto, azetoV2 } from "./baseAPIsConfig";
// Base URLs
export const BaseUrlCore = azeto.Core;
export const BaseUrlCoreV2 = azetoV2.Core;
const BaseUrlNotification = azeto.Notification;
const BaseUrlNotificationV2 = azetoV2.Notification;
const BaseUrlAccounting = azeto.Account;
const BaseUrlAccountingV2 = azetoV2.Account;
const BaseUrlWallet = azeto.Wallet;
const BaseUrlMeili = azeto.Meili;

// Full URLs
export const recordUserActivityApi = `${BaseUrlCore}record-user-activity/0/`;

// payment
export const cartApi = `${BaseUrlAccounting}cart/`;
export const checkDiscountApi = `${BaseUrlAccounting}check-discount/`;
export const finalizePaymentApi = `${BaseUrlAccountingV2}finalize-payment/`;

export const userAccessListApi = `${BaseUrlCore}user-access-list/`; // API for checking subscription-code

export const salesPackagesApi = `${BaseUrlAccounting}sales-package/`; // API for getting personal-purchase packages
export const unitOfTimeApi = `${BaseUrlAccounting}unit-of-time/`; // API for getting group-purchase packages time sets
export const calculateUnitOfTimePriceApi = `${BaseUrlAccounting}calculate_unit_of_time_price/`;

// wallet
export const walletBalanceApi = `${BaseUrlWallet}account/`;

export const educationApi = `${BaseUrlCore}education/`;

export const unreadMessagesApi = `${BaseUrlNotificationV2}un-read-message`;
export const setMessagesAsReadApi = `${BaseUrlNotificationV2}set-message-as-read`;

export const constantApi = `${BaseUrlCore}constants/`;
export const profileApi = `${BaseUrlCoreV2}profile/`;
export const userProfileApi = `${BaseUrlCore}user-profile/`;
export const gradeCategoriesApi = `${BaseUrlCore}grade_categories/`;
export const gradeApi = `${BaseUrlCore}grade/`;
export const hashtagApi = `${BaseUrlCore}hashtag/`;
export const subjectApi = `${BaseUrlCore}subject/`;
export const interestApi = `${BaseUrlCoreV2}interest/`;
export const commentApi = `${BaseUrlNotification}comment/`;

// login/register
export const loginApi = `${BaseUrlCoreV2}api-token/`;
export const logoutApi = `${BaseUrlCoreV2}api-token/logout/`;
export const checkUserExistApi = `${BaseUrlCore}check-user-exist/`;
export const loginRequestCodeApi = `${BaseUrlCore}login-request-code/`;
export const loginRequestCodeVerificationApi = `${BaseUrlCore}login-request-code-verification/`;
export const resetPasswordApi = `${BaseUrlCore}reset-password/`;
export const changePasswordApi = `${BaseUrlCore}change-password/`;
export const resetPasswordRequestApi = `${BaseUrlCore}reset-password-request/`;
export const resetPasswordCheckCodeApi = `${BaseUrlCore}reset-password-check-code/`;

export const registerApi = `${BaseUrlCore}register/`;
export const registerRequestCodeApi = `${BaseUrlCore}register-request-code/`;
export const registerRequestCodeVerificationApi = `${BaseUrlCore}register-request-code-verification/`;

// sim
export const simApi = `${BaseUrlCore}sim/`;
export const simDetailsApi = `${BaseUrlCore}sim-details/`;
export const exerciseApi = `${BaseUrlCore}exercise/`;
export const qiuzApi = `${BaseUrlCore}quiz/`;
export const bookApi = `${BaseUrlCore}book/`;
export const toggleSimBookmarkApi = `${BaseUrlCore}toggle-sim-bookmark/`;
export const rateSimApi = `${BaseUrlCore}rate-the-sim/`;
export const simReportApi = `${BaseUrlCore}sim-report/`;
export const simReportPdfApi = `${BaseUrlCore}sim-report-pdf/`;
export const sendSimReport = `${BaseUrlCore}send-sim-report/`;

export const fileApi = `${BaseUrlCoreV2}file/`;
export const checkTeacherApi = `${BaseUrlCore}check-teacher/`;
export const messageApi = `${BaseUrlNotificationV2}message/`;

// search
export const serachApi = `${BaseUrlCoreV2}search/`;
export const mailiSearchSimulationsApi = `${BaseUrlMeili}simolations/search/`;

// profile
export const mySimsApi = `${BaseUrlCore}my-sims/`;
export const myInvoiceApi = `${BaseUrlAccounting}my-Invoice/`;
export const myTokenApi = `${BaseUrlAccounting}my-token/`;
export const userPointApi = `${BaseUrlCore}user-point/`;
export const userPointChartApi = `${BaseUrlCore}user-point-chart/`;
export const invitationApi = `${BaseUrlAccounting}invitation/`;
export const invitationCodeReportApi = `${BaseUrlAccounting}invitation-code-report/`;
export const banUserApi = `${BaseUrlAccounting}ban-user/`;

// home page
export const homeCommentApi = `${BaseUrlNotification}home-comment/`;
export const wallboardApi = `${BaseUrlCoreV2}wall-board/`;
